import { constants, mediaQueryStyles } from "@newsela/angelou";

const { Breakpoints } = constants.breakpoints;
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const newBadgeCss = {
  root: {
    [breakpoint.downTo(Breakpoints.md)]: {
      marginLeft: "21px",
    },
  },
};
